
export const DOWNLOAD_STATEMENT = 'DOWNLOAD_STATEMENT';